export const MIDDLEWARE_IP = 'https://mid.panelklienta.k.pl';
